import { render } from "./FileListWithThumbnail.vue?vue&type=template&id=65908053"
import script from "./FileListWithThumbnail.vue?vue&type=script&lang=ts"
export * from "./FileListWithThumbnail.vue?vue&type=script&lang=ts"
script.render = render

export default script